module.exports = __webpack_public_path__ + "img/logo-qiw.42b6c32b.png";